import { render, staticRenderFns } from "./ShuttleList.vue?vue&type=template&id=df4e3afe&scoped=true"
import script from "./ShuttleList.vue?vue&type=script&lang=js"
export * from "./ShuttleList.vue?vue&type=script&lang=js"
import style0 from "./ShuttleList.vue?vue&type=style&index=0&id=df4e3afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4e3afe",
  null
  
)

export default component.exports